module.exports = __webpack_public_path__ + "img/duplicationMenu.7a2a5aa5.png";